<template>
    <!-- EXPIRATION MESSAGE -->
    <div class="alert alert-info m-0 mb-6 expiration-message">
        {{$l10n.__("Votre offre a été réalisée par un commercial Sellsy, certains éléments ne sont pas modifiables.")}}
        <span class="block bold">
            {{ $l10n.__("Cette offre expire le") }} {{ expirationDate | dateFormatter("NORMAL_DATE", false) }}
        </span>
    </div>
</template>
<script>
export default {
    props: {
        expirationDate: {
            type: String,
            required: true
        }
    }
}
</script>
<style lang="scss" scoped>
    .expiration-message {
        max-width: 620px;
    }
</style>